// [マイページ] お気に入り会社
import Image from "components/common/images/Image";
import { FavoriteCorpModel } from "models";
import React from "react";
import { Link } from "react-router-dom";

type PROPS = {
  items?: FavoriteCorpModel[] | null;
};

const FavoriteCorps: React.FC<PROPS> = (props) => {
  if (!props.items || props.items.length === 0) {
    return (
      <div className="p-4">
        <div className="flex justify-between border-b border-b-black p-1">
          <div className="font-bold">お気に入り会社</div>
        </div>
        <div className="mt-4 h-40"></div>
      </div>
    );
  }
  return (
    <div className="mt-4 p-4">
      <div className="flex justify-between border-b border-b-black p-1">
        <div className="font-bold">お気に入り会社</div>
        <Link to="/favorite-company/" className="text-jhk-blue hover:underline">
          ＞ お気に入り会社一覧を見る
        </Link>
      </div>
      <div className="mt-4 w-full flex justify-start">
        {props.items.map((item, index) => {
          if (item.corp_id === "") {
            return <div key={index} className="flex-1"></div>;
          }
          return (
            <Link
              key={index}
              className="flex-1"
              to={`/company-detail/${item.favorite_corp_id}/`}
            >
              <div className="p-2 hover:bg-gray-100">
                <Image
                  data={item.logo_image}
                  width="100%"
                  height={`calc(calc(98vw - 20rem) / ${props.items?.length})`}
                />
                <div className="truncate" title={item.corp_name}>{item.corp_name}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FavoriteCorps;
